import { useMutation, useQuery } from "react-query";
import {
  getAllSolutions,
  getDefaultIndex,
  getDefaultIndexOrderSettings,
  setDefaultIndexes,
  setDefaultIndexOrderSettings,
} from "../api/solutions";

// Get All Solutions
export const useGetAllSolutions = (options = {}) =>
  useQuery("getAllSolutions", getAllSolutions, options);

// Get Default Index
export const useGetDefaultIndex = (id, options = {}) => {
  return useQuery(["getDefaultIndex", id], () => getDefaultIndex(id), {
    enabled: !!id,
    ...options,
  });
};

// Get Default Index Order Settings
export const useGetDefaultIndexOrderSettings = (id, options = {}) => {
  return useQuery(
    ["getDefaultIndexOrderSetting", id],
    () => getDefaultIndexOrderSettings(id),
    {
      enabled: !!id,
      ...options,
    },
  );
};

// Set Default Indexes
export const useSetDefaultIndexes = (options) => {
  return useMutation(setDefaultIndexes, options);
};

// Set Default Index Order Settings
export const useSetDefaultIndexOrderSettings = (options) => {
  return useMutation(setDefaultIndexOrderSettings, options);
};

export default {
  useGetAllSolutions,
  useGetDefaultIndex,
  useGetDefaultIndexOrderSettings,
  useSetDefaultIndexes,
  useSetDefaultIndexOrderSettings,
};
